__turbopack_context__.v({
  "alert": "RegistrationForm-module-scss-module__nS95Ya__alert",
  "backButton": "RegistrationForm-module-scss-module__nS95Ya__backButton",
  "nextButton": "RegistrationForm-module-scss-module__nS95Ya__nextButton",
  "signUpButton": "RegistrationForm-module-scss-module__nS95Ya__signUpButton",
});
